<template>
  <div id="ProfileStage">
    <div class="ProfileQuestion">
      <div class="Prompt">I have a criminal record or arrest record in Florida:</div>
      <el-radio-group v-model="ES0Q1" size="mini">
        <el-radio-button label="Yes"></el-radio-button>
        <el-radio-button label="No"></el-radio-button>
      </el-radio-group>
    </div>
    <div class="ProfileQuestion">
      <div class="Prompt">I paid all the fines and fees associated with my criminal case:</div>
      <el-radio-group v-model="ES0Q2" size="mini">
        <el-radio-button label="Yes"></el-radio-button>
        <el-radio-button label="No"></el-radio-button>
      </el-radio-group>
    </div>
    <div class="ProfileQuestion">
      <div class="Prompt">I have more than one conviction:</div>
      <el-radio-group v-model="ES0Q10" size="mini">
        <el-radio-button label="Yes"></el-radio-button>
        <el-radio-button label="No"></el-radio-button>
      </el-radio-group>
    </div>
    <div class="ProfileQuestion">
      <div class="Prompt">I was denied a job because of my credit report:</div>
      <el-radio-group v-model="ES0Q3" size="mini">
        <el-radio-button label="Yes"></el-radio-button>
        <el-radio-button label="No"></el-radio-button>
      </el-radio-group>
    </div>
    <div class="ProfileQuestion">
      <div class="Prompt">I was denied housing because of my credit report:</div>
      <el-radio-group v-model="ES0Q4" size="mini">
        <el-radio-button label="Yes"></el-radio-button>
        <el-radio-button label="No"></el-radio-button>
      </el-radio-group>
    </div>
    <div class="ProfileQuestion">
      <div class="Prompt">I am the victim of identity theft:</div>
      <el-radio-group v-model="ES0Q5" size="mini">
        <el-radio-button label="Yes"></el-radio-button>
        <el-radio-button label="No"></el-radio-button>
      </el-radio-group>
    </div>
    <div class="ProfileQuestion">
      <div class="Prompt">I was denied credit because of my credit report:</div>
      <el-radio-group v-model="ES0Q6" size="mini">
        <el-radio-button label="Yes"></el-radio-button>
        <el-radio-button label="No"></el-radio-button>
      </el-radio-group>
    </div>
    <div class="ProfileQuestion">
      <div class="Prompt">I was a juvenile (under 18) at the time:</div>
      <el-radio-group v-model="ES0Q7" size="mini">
        <el-radio-button label="Yes"></el-radio-button>
        <el-radio-button label="No"></el-radio-button>
      </el-radio-group>
    </div>
    <template v-if="needsAdditionalJuvenile">
      <div class="ProfileQuestion">
        <div class="Prompt">What is your current age?</div>
        <el-input placeholder="18" v-model="ES0Q8" :maxlength="3" style="width: 98px;"></el-input>
      </div>
      <div class="ProfileQuestion">
        <div class="Prompt">I completed pre-trial diversion:</div>
        <el-radio-group v-model="ES0Q9" size="mini">
          <el-radio-button label="Yes"></el-radio-button>
          <el-radio-button label="No"></el-radio-button>
        </el-radio-group>
      </div>
    </template>
    <div style="clear: both; line-height: 0px; height: 0px;">&nbsp;</div>
    <div align="center"><el-button @click="next" type="primary" style="margin-left: auto; margin-right: auto;">Continue</el-button></div>
  </div>
</template>

<script>
import EventBus from '../../EligibilityEventBus.js'

import { RadioGroup, RadioButton, Button, Input } from 'element-ui'

export default {
  data: function () {
    return {
      ES0Q1: null,
      ES0Q2: null,
      ES0Q3: null,
      ES0Q4: null,
      ES0Q5: null,
      ES0Q6: null,
      ES0Q7: null,
      ES0Q8: null,
      ES0Q9: null,
      ES0Q10: null
    }
  },

  components: {
    'el-radio-group': RadioGroup,
    'el-radio-button': RadioButton,
    'el-button': Button,
    'el-input': Input
  },

  methods: {
    next () {
      // You're leaving the "Background" page.
      if (!this.ES0Q1 || !this.ES0Q2 || !this.ES0Q3 || !this.ES0Q4 || !this.ES0Q5 || !this.ES0Q6 || !this.ES0Q7 || !this.ES0Q10) {
        alert('Please answer all the questions.')
      } else {
        EventBus.$emit('ProfileComplete', { 'ES0Q1': this.ES0Q1, 'ES0Q2': this.ES0Q2, 'ES0Q3': this.ES0Q3, 'ES0Q4': this.ES0Q4, 'ES0Q5': this.ES0Q5, 'ES0Q6': this.ES0Q6, 'ES0Q7': this.ES0Q7, 'ES0Q8': this.ES0Q8, 'ES0Q9': this.ES0Q9, 'ES0Q10': this.ES0Q10 })
      }
    }
  },

  computed: {
    needsAdditionalJuvenile: function () {
      if (this.ES0Q7 === 'Yes') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
div.ProfileQuestion {
  display:inline-block;
  margin-bottom: 20px;
  margin-right: 20px;
  min-width: 290px;
  max-width: 500px;
  height: 60px;
}

div.Prompt {
  max-width: 184px;
  padding-right: 8px;
  float: left;
  text-align: left;
}

.el-radio-group {
  float: right;
  clear: right;
}

.el-input {
  float: right;
  clear: right;
}

#ProfileStage {
  display:inline-block;
  text-align: center;
}
</style>
